module.exports = __webpack_public_path__ + "static/media/post-new-quick-signal.4d0478c8.svg";